module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-11-eff65db43a0ca30f5af9c71e47538427.svg";